import React, { useEffect, useState, useRef } from 'react';
import { Layout, Table, Input, Button, Space, Modal, Form, InputNumber } from 'antd';
import Highlighter from 'react-highlight-words';
import {
  DownloadOutlined,
  SearchOutlined,
  ExclamationCircleOutlined,
  VerticalAlignMiddleOutlined, FileExcelOutlined, PlusOutlined
} from '@ant-design/icons';
import { collection, doc, setDoc, deleteDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { db } from '../FirebaseApp';
import { useDispatch, useSelector } from "react-redux";
import { getItems, selectItems } from "../redux/reducers/items";
import { Link } from 'react-router-dom'
import { Excel } from 'antd-table-saveas-excel';

const { Content } = Layout;
const { TextArea } = Input;

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 20 },
};

let newOrder = null;

const Item = () => {
  const dispatch = useDispatch();
  const items = useSelector(selectItems);
  const formRef = React.createRef(null);

  const [datas, setDatas] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [visibleAdd, setVisibleAdd] = useState(null);
  const [visibleMod, setVisibleMod] = useState(null);

  const [name, setName] = useState('');
  const [score, setScore] = useState(null);
  const [description, setDescription] = useState('');
  const [id, setID] = useState(null);
  let searchInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    let newData = [];
    if(items !== null) {
      newOrder = Object.keys(items).length
      for (const itemsKey in items) {
        const item = items[itemsKey]

        newData.push({
          key: item.id,
          id: item.id,
          name: item.data().name,
          score: item.data().score,
          description: item.data().description,
          order: item.data().order,
        })
      }
    }

    setDatas(newData)
  }, [items]);

  const showAddModal = () => {
    setVisibleAdd(true)
  };
  const showModModal = () => {
    setVisibleMod(true)
  };
  const hideModal = () => {
    setVisibleMod(false)
    setVisibleAdd(false)
  };

  const addItem = async (value) => {
    const docRef = doc(collection(db, "items"));
    await setDoc(docRef, {'id': docRef.id, ...value, create: serverTimestamp(), update: serverTimestamp(), order: newOrder} );
    dispatch(getItems());
  };

  const updateItem = async (value) => {
    const docRef = doc(db, "items", id);
    await updateDoc(docRef, {...value, update: serverTimestamp()});
    dispatch(getItems());
  };

  const deleteConfirm = () => {
    Modal.confirm({
      title: '해당 품목을 삭제하시겠습니까?',
      icon: <ExclamationCircleOutlined style={{color:"red"}}/>,
      content: '',
      okText: '삭제',
      cancelText: '취소',
      async onOk() {
        await deleteDoc(doc(db, "items", id));
        dispatch(getItems());
        hideModal();
      }
    });
  }

  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInputRef = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0])
              setSearchedColumn(dataIndex)
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInputRef.select(), 100);
      }
    },
    render: text =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  };

  const handleReset = clearFilters => {
    clearFilters();
    setSearchText('')
  }; 

  const columns = [
    {
      title: 'No.',
      dataIndex: 'order',
      key: 'order',
      render: (order) => {
        return (
          order+1
        );
      }
    },
    {
      title: '품목',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      sorter: (a, b) => a.name.length - b.name.length,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '코인',
      dataIndex: 'score',
      key: 'score',
      sorter: (a, b) => a.score - b.score,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '품목 설명',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: '비고',
      dataIndex: 'active',
      key: 'active',
      align: 'center',
      render: (text, record, index) => {
        return (
          <Button type="primary" ghost onClick = {
            () => {
              setName(record.name);
              setScore(record.score);
              setDescription(record.description);
              setID(record.id);
              showModModal();
            }
          }>수정</Button>
        );
      },
      excelRender: () => {
        return;
      }
    },
  ];
  return (
    <Content style={{ margin: '0 16px', height: '100%' }}>
      <div className="site-layout-background" style={{ padding: 24, height: '100%' }}>
        <Link to="/item/sort">
          <Button
            icon={<VerticalAlignMiddleOutlined/>}
            type="second"
            style={{position: 'absolute', left: '240px',}}
          >
            품목 정렬
          </Button>
        </Link>
        <Button
          icon={<PlusOutlined/>}
          type="primary"
          style={{ position:'absolute', right: '40px',}}
          onClick={showAddModal}
        >
          품목 추가
        </Button>
        <Table columns={columns} dataSource={datas} style={{ marginTop: '50px' }} rowKey={record => record.id}/>
        
        {/* 추가하기 모달 */}
        <Modal
          visible={visibleAdd}
          onOk={
            () => {
              formRef.current
                .validateFields()
                .then(values => {
                  formRef.current.resetFields();
                  addItem(values);
                  hideModal();
                })
                .catch(info => {
                  console.log('Validate Failed:', info);
                });
            }
          }
          onCancel={hideModal}
          okText="추가"
          cancelText="취소"
        >
          <p style={{fontWeight:'600', fontSize: '16px'}}>품목 정보 추가</p>
          <Form 
            ref={formRef}
            {...layout} 
            name="nest-messages" >
            <Form.Item name={'name'} label="품목 이름" rules={[{ required: true, message: '품목 이름을 입력하세요.' }]}>
              <Input />
            </Form.Item>
            <Form.Item name={'score'} label="획득 점수" rules={[{ required: true, message: '획득 점수를 입력하세요.' }]}>
              <InputNumber />
            </Form.Item>
            <Form.Item name={'description'} label="설명" rules={[{ required: true, message: '설명을 입력하세요.' }]}>
              <TextArea />
            </Form.Item>
          </Form>
        </Modal>

        {/* 수정 모달 */}
        <Modal
          visible={visibleMod}
          onCancel={hideModal}
          footer={[
            <Button key="delete" type="primary" danger onClick={deleteConfirm} style={{position: 'absolute', left: '20px'}}>삭제</Button>,
            <Button key="cancel"  onClick={hideModal}>취소</Button>,
            <Button key="submit" type="primary" 
              onClick={() => {
                formRef.current
                  .validateFields()
                  .then(values => {
                    formRef.current.resetFields();
                    updateItem(values);
                    hideModal();
                  })
                  .catch(info => {
                    console.log('Validate Failed:', info);
                  });
                }}>
                  수정</Button>]}>
          <p style={{fontWeight:'600', fontSize: '16px'}}>품목 정보 수정</p>
          <Form
            ref={formRef}
            {...layout} 
            name="nest-messages" 
            fields={[
              {
                name: ["name"],
                value: name,
              },
              {
                name: ["score"],
                value: score,
              },
              {
                name: ["description"],
                value: description,
              },
            ]}>
            <Form.Item name={'name'} label="품목 이름" rules={[{ required: true, message: '품목 이름을 입력하세요.' }]}>
              <Input/>
            </Form.Item>
            <Form.Item name={'score'} label="획득 점수" rules={[{ required: true, message: '획득 점수를 입력하세요.' }]}>
              <InputNumber />
            </Form.Item>
            <Form.Item name={'description'} label="설명" rules={[{ required: true, message: '설명을 입력하세요.' }]}>
              <TextArea />
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </Content>
  );
}

export default Item;